import { openPremiumPageUpgradeModal } from '@gik/checkout/utils/openPremiumPageUpgradeModal';
import routes from '@gik/core/routes';
import bemBlock from '@gik/core/utils/bemBlock';
import withComponentErrorBoundary from '@gik/core/utils/withComponentErrorBoundary';
import { Button } from '@gik/ui/Button';
import { SvgIcon } from '@gik/ui/SvgIcon/SvgIcon';
import NewspaperIcon from '@heroicons/react/outline/NewspaperIcon';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { RelatedArticles } from '.';
import { DisableSuggestionsButton } from '../DisableSuggestionsButton';
import { SidebarSection } from '../SidebarSection';
import { translationKeys } from './i18n/en';
import { useInkind } from '@gik/api/inkinds/inkind';
import { patchInkind } from '@gik/api/inkinds/inkinds';
import type { PatchInkindPageRequest } from '@gik/core/models/gik/InkindPage';

interface IRelatedArticlesSectionProps {
  inkindRouteId: string;
  showDisable?: boolean;
}

function RelatedArticlesSectionComp({ inkindRouteId, showDisable = false }: IRelatedArticlesSectionProps) {
  const { t } = useTranslation();
  const bem = bemBlock('related-articles-section');
  const { data: inkindPage, mutate } = useInkind(inkindRouteId);
  const isPremium = inkindPage?.isPremium;

  async function onClickDisable() {
    if (!isPremium)
      return openPremiumPageUpgradeModal({
        initiatedOn: 'inkindPage',
        variant: 'hideSuggestions',
        patchInkindRequest: {
          enableSuggestedArticles: false,
        },
      });

    const patchInkindPageData: PatchInkindPageRequest = {
      enableSuggestedArticles: false,
    };

    await patchInkind(inkindRouteId, patchInkindPageData);
    await mutate();
  }

  // TODO: extract append to DisableSidebarFeatureButton
  return (
    <SidebarSection
      title={t(translationKeys.title).toString()}
      className={bem()}
      {...((showDisable && {
        append: <DisableSuggestionsButton className={bem('disable-button')} onClick={onClickDisable} />,
      }) ||
        {})}
    >
      <RelatedArticles inkindRouteId={inkindRouteId} />
      <Button
        type={'a'}
        href={routes.blog}
        block
        prepend={<SvgIcon size="lg" Icon={NewspaperIcon} />}
        className={bem('see-all-button')}
      >
        {t(translationKeys.seeAllArticles).toString()}
      </Button>
    </SidebarSection>
  );
}

export const RelatedArticlesSection = withComponentErrorBoundary(RelatedArticlesSectionComp);
